module.exports = __webpack_public_path__ + "static/media/loading-fill-side.7120c38a.png";